import React, { SetStateAction, useContext, useEffect, useState } from 'react'
import { ICreateReductionAction, IReductionActionForReportPeriod, ReductionActionType } from '../../../shared/services/reduction-action/reduction-action.model'
import { ReductionActionLibrary } from '../../presentation-components/reduction-components/reduction-action-library'
import ReductionActionService from '../../../shared/services/reduction-action/reduction-action.service'
import { ReportPeriodContext } from '../../../context/report-periods/report-periods'
import { UserDetailsContext } from '../../../context/user-details/user-details'
import { UserNotificationsContext } from '../../../context/user-notifications/user-notifications'
import { PageOuterContainer } from '../../../root-components/layouts/page-outer-container'
import { IconName } from '../../../shared/interfaces/icon-picker.model'
import { PageHeading } from '../../presentation-components/display-elements-components/page-heading'
import { AddCustomReductionActionDialog } from '../../dialogs/reduction/add-custom-reduction-action-dialog'
import { useReportPeriodWatcher } from '../../../hooks/use-report-period-watcher'

export const ReductionActionLibraryPage = ({
  actionType = 'reduction',
  backLink = '/reduction-plan/actions',
  pageTitle = 'Reduction Action Library',
  actionButtonText = 'Super Admin Add Reduction Action',
}: {
  actionType?: ReductionActionType;
  backLink?: string;
  pageTitle?: string;
  actionButtonText?: string;
}) => {
  const reportPeriodWatcher = useReportPeriodWatcher({ redirectUrl: backLink })
  //Services
  const userDetailsContext = useContext(UserDetailsContext)
  const userDetails = userDetailsContext.userDetails
  const userNotificationsContext = useContext(UserNotificationsContext)
  const reductionActionService = new ReductionActionService()
  const reportPeriodContext = useContext(ReportPeriodContext)
  //State
  const [organisationReductionActions, setOrganisationReductionActions] = useState<IReductionActionForReportPeriod[]>()
  const [openReductionActionDialog, setOpenReductionActionDialog] = React.useState(false);
  const [newReductionAction, setNewReductionAction] = useState<ICreateReductionAction>({
    name: '',
    description: '',
    groupId: '',
    categoryId: [],
    icon: '',
  })
  //Loading State
  const [isDialogSubmitting, setIsDialogSubmitting] = useState<boolean>(false)

  useEffect(() => {
    getAllActionsForOrganisation();
  }, [reportPeriodContext.lastSelectedOpenReportId])

  const getAllActionsForOrganisation = () => {
    if (reportPeriodContext.lastSelectedOpenReportId)
      reductionActionService.getAllReductionActionsForReportPeriod(`reportPeriodId=${reportPeriodContext.lastSelectedOpenReportId}&actionType=${actionType}`)
        .then(response => {
          setOrganisationReductionActions(response)
        })
        .catch(err => console.log(err))
  }

  const closeReductionActionDialogHandler = () => {
    setOpenReductionActionDialog(false);
  };


  const submitActionHandler = (values: ICreateReductionAction, resetForm: () => void, setSelectedCategoriesId: React.Dispatch<SetStateAction<any>>) => {
    if (!isDialogSubmitting) {
      setIsDialogSubmitting(true)
      reductionActionService.createReductionAction({ ...values, actionType })
        .then(response => {
          setOpenReductionActionDialog(false)
          setSelectedCategoriesId([])
          getAllActionsForOrganisation()
          resetForm()
          userNotificationsContext.openSnackbar({ open: true, message: 'Added successfully' });
          setIsDialogSubmitting(false)
        })
        .catch(err => {
          userNotificationsContext.openSnackbar({ open: true, message: 'There was an error, please try again', backgroundColor: 'text.primary' });
          setIsDialogSubmitting(false)
          console.log(err)
        })
    }

  }

  return (
    <PageOuterContainer>
      <PageHeading
        title={pageTitle}
        includeBackButton={true}
        backButtonLink={backLink}
        backButtonText='Back to plan'
        hasTabs={false}
        includeActionButton={true}
        actionButtonIcon={IconName.AdminPanelSettingsOutlined}
        actionButtonHandler={() => setOpenReductionActionDialog(true)}
        actionButtonText={actionButtonText}
        hideShowActionButton={!userDetails?.isSuperAdmin}
        actionButtonVariant='outlined'
      />
      {organisationReductionActions &&
        <ReductionActionLibrary
          actionType={actionType}
          reductionActionsForOrganisation={organisationReductionActions}
          getAllActionsForOrganisation={getAllActionsForOrganisation} />}
      {openReductionActionDialog && 
        <AddCustomReductionActionDialog
          isSubmitting={isDialogSubmitting}
          newReductionAction={newReductionAction}
          isSuperAdmin={true}
          open={openReductionActionDialog}
          closeHandler={closeReductionActionDialogHandler}
          submitHandler={submitActionHandler} />}
    </PageOuterContainer>
  )

}
